module.exports = __webpack_public_path__ + "static/img/Cow.f859902.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/cz_animal/Cow.svg
// module id = 1357
// module chunks = 0